import { LinkButtonWithIcon } from "@/components/Buttons/LinkButtonWithIcon"
import FormattedEmail from "@/components/FormattedEmail"
import { BuildingIcon } from "@/components/Icons"
import { EyeIcon } from "@/components/Icons"
import { SheetField, SheetFieldGrid, SheetSection } from "@/components/Sections/SheetSection"
import { P3 } from "@/components/Typographies"
import { getClusterLinkSheet } from "@/domain/cluster/getClusterLinkSheet"
import { getCollaboratorLinkSheet } from "@/domain/collaborator/getCollaboratorLinkSheet"
import { getDisplayedName as getDisplayedCollaboratorName } from "@/domain/collaborator/getDisplayedName"
import type {
  ClusterJsonldReadCollectionSharedData,
  SharedDataJsonldReadCollectionSharedDataTo,
  UserJsonldReadCollectionSharedData,
} from "@/networking/api"
import { isNotNullNorUndefined } from "@/utils/ts-utils"
import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"

type Props = {
  collaborator?: UserJsonldReadCollectionSharedData | SharedDataJsonldReadCollectionSharedDataTo
  cluster?: ClusterJsonldReadCollectionSharedData
}

export const RequestorSection = ({ collaborator, cluster }: Props) => {
  const intl = useIntl()
  const navigateTo = useNavigate()

  return (
    <SheetSection
      title={intl.formatMessage({ id: "userSharedData.collaboratorFrom.details" })}
      icon={BuildingIcon}
    >
      <SheetFieldGrid>
        {isNotNullNorUndefined(collaborator) && (
          <SheetField label={intl.formatMessage({ id: "userSharedData.collaboratorFrom.name" })}>
            <P3 display="block">
              {getDisplayedCollaboratorName(collaborator)}
              <LinkButtonWithIcon
                display="inline-block"
                ml="2"
                icon={EyeIcon}
                onClick={() => navigateTo(getCollaboratorLinkSheet(collaborator))}
              />
            </P3>
            <P3 display="block">
              <FormattedEmail email={collaborator?.email} />
            </P3>
          </SheetField>
        )}
        <SheetField label={intl.formatMessage({ id: "userSharedData.clusterFrom.name" })}>
          <P3 display="block">
            {cluster?.name}{" "}
            <LinkButtonWithIcon
              display="inline-block"
              ml="2"
              icon={EyeIcon}
              onClick={() => navigateTo(getClusterLinkSheet(cluster))}
            />
          </P3>
        </SheetField>
      </SheetFieldGrid>
    </SheetSection>
  )
}
